import React from "react";
import { withStyles } from "material-ui/styles";
import FooterTableCell from "./FooterTableCell";
import FooterTableRow from "./FooterTableRow";

const styles = () => ({
  root: {
    background: "#173f34",
    borderRadius: "14px"
  }
});

const TotalBillRow = ({ classes, netTotal }) => (
  <FooterTableRow
    className={classes.root}
    style={{
      boxShadow: "0 8px 22px rgba(23, 63, 52, 0.16)"
    }}
  >
    <FooterTableCell
      numeric
      style={{
        width: "150px",
        paddingTop: 18,
        paddingBottom: 18,
        background: "#173f34"
      }}
    />

    <FooterTableCell
      numeric
      style={{
        paddingTop: 18,
        paddingBottom: 18,
        background: "#173f34"
      }}
    />

    <FooterTableCell
      style={{
        background: "#173f34"
      }}
    />

    <FooterTableCell
      style={{
        paddingLeft: "15px",
        paddingTop: 18,
        paddingBottom: 18,
        background: "#173f34",
        color: "#d8eee5",
        fontSize: 12,
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.4px"
      }}
    >
      Net bill amount
    </FooterTableCell>

    <FooterTableCell
      numeric
      style={{
        paddingTop: 18,
        paddingBottom: 18,
        background: "#173f34",
        color: "#ffffff",
        fontSize: 21,
        fontWeight: 900
      }}
    >
      {"\u20A6"}{Number(netTotal || 0).toLocaleString()}
    </FooterTableCell>
  </FooterTableRow>
);

export default withStyles(styles)(TotalBillRow);
